import * as React from "react";

const MyImageField = ({ record = {}, source }) =>
  <img src={record[source]} style={{maxWidth: '50px'}} alt=""/>;

export default MyImageField;
